<h2 mat-dialog-title>API Key</h2>

<form #apiKeyForm="ngForm" fxLayout="column" fxFill fxLayoutGap fxLayoutAlign="center center" *ngIf="apiKey">
  <div fxFill>
    <mat-slide-toggle fxFill name="enabled" [checked]="apiKey.enabled"
      [(ngModel)]="apiKey.enabled" [disabled]="!isEnabled('enabled')">
      Active
      <mat-hint> - unchecking will disable the API key</mat-hint>
    </mat-slide-toggle>
  </div>

  <mat-dialog-content fxFill>
    <mat-form-field fxFill *ngIf="apiKey.id">
      <input matInput disabled placeholder="KeyId" name="id" [(ngModel)]="apiKey.id">
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions fxLayoutAlign="end">
      <button mat-raised-button (click)="close()">Close</button>
      <button color="primary" mat-raised-button (click)="save()" *ngIf="isEnabled('save')" [disabled]="!apiKeyForm.valid || !apiKeyForm.dirty">Save</button>
  </mat-dialog-actions>
</form>
